import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { useAuth } from '../../lib/auth/context';
import { useUser } from '../../lib/auth/hooks';

const SESSION_TTL_MS = 60 * 60 * 1000;
const WARN_BEFORE_MS = 5 * 60 * 1000;

export function IdleWarning() {
  const { data: user } = useUser();
  const { refreshUser, logout } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const warnAt = SESSION_TTL_MS - WARN_BEFORE_MS;
    const t = setTimeout(() => setOpen(true), warnAt);
    return () => clearTimeout(t);
  }, [user]);

  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Oturumunuz sona eriyor</DialogTitle>
          <DialogDescription>
            Oturumunuz 5 dakika içinde otomatik olarak kapatılacak. Devam etmek ister misiniz?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={async () => {
              await logout();
              setOpen(false);
            }}
          >
            Çıkış Yap
          </Button>
          <Button
            onClick={async () => {
              await refreshUser();
              setOpen(false);
            }}
          >
            Devam Et
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
